export function FallbackView() {
  return (
    <div className='splash-screen'></div>
  )
}
